module.exports = __webpack_public_path__ + "static/orumlabs-af269c01ab3b1c8e69aad8cce0fee437.png";